import { render, staticRenderFns } from "./manualApproveTicket.vue?vue&type=template&id=acfa3e0c&lang=pug"
import script from "./manualApproveTicket.vue?vue&type=script&lang=js"
export * from "./manualApproveTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports